import { Text, Box } from 'dracula-ui'; 

function Footer() {
    return(
        <Box className="drac-mt-lg drac-text-center">
            <Text>
                © David Granjon, 2023
            </Text>
        </Box>
    )
}

export default Footer;